module.exports = __webpack_public_path__ + "static/img/4areaB_17.30d0b4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_17.png
// module id = 1190
// module chunks = 1